import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Tooltip from './tooltip'
import styles from './help_tooltip.module.scss'

export default class HelpTooltip extends Component {
  constructor(props) {
    super(props)

    this.state = {
      hidden: true
    }
  }

  handleTooltip(hidden) {
    this.setState({
      hidden
    })
  }

  render() {
    const { message } = this.props
    const { hidden } = this.state

    return (
      <div className={styles.container}>
        <i
          className="ic-help"
          onMouseEnter={() => this.handleTooltip(false)}
          onMouseLeave={() => this.handleTooltip(true)}
        />
        <Tooltip className={styles.helpTooltip} hidden={hidden} message={message} />
      </div>
    )
  }
}

HelpTooltip.propTypes = {
  message: PropTypes.string.isRequired
}
